import React, { Component } from 'react';

import InlineEditIncome from './IncomeExpenses/Income';
import InlineEditRent from './IncomeExpenses/Rent';
import InlineEditLoans from './IncomeExpenses/Loans';
import InlineEditCreditCards from './IncomeExpenses/CreditCards';
import InlineEditHouseholdIncome from './IncomeExpenses/HouseholdIncome';
import InlineEditInvestmentIncome from './IncomeExpenses/InvestmentIncome';


class IncomeExpenses extends Component {

  render() {     
     var householdIncome = Number.parseFloat(this.props.incomeExpenses.householdincome);
     var investableFunds = Number.parseFloat(this.props.incomeExpenses.investmentincome);
     var displayFinancials = (householdIncome > 0 || investableFunds > 0) ? true : false;     
     let fragment;

    if (displayFinancials) {
      fragment =
        <div>
          <InlineEditHouseholdIncome {...this.props.incomeExpenses} {...this.props} />
          <InlineEditInvestmentIncome {...this.props.incomeExpenses} {...this.props} />
        </div>;        
    }

    return (
      <div>                
        <h3>Income &amp; expenses</h3>
        <div className="static-field-container">
          <InlineEditIncome {...this.props.incomeExpenses} {...this.props}  />
          <InlineEditRent {...this.props.incomeExpenses} {...this.props} />
          <InlineEditLoans {...this.props.incomeExpenses} {...this.props}  />
          <InlineEditCreditCards {...this.props.incomeExpenses} {...this.props} />
          {fragment}      
        </div>
      </div>
    );
  }
}

export default IncomeExpenses;


// WEBPACK FOOTER //
// ./src/containers/Review/InlineEdit/IncomeExpenses.js